import { useQuery } from '@tanstack/react-query';
import type { MetricsSummary } from '@contracts/system';
import { api } from '../lib/api';
import { ms } from '../lib/format';
import { Panel } from './Panel';

const SERIES: { key: string; label: string; hint: string }[] = [
  { key: 'feed', label: 'Feed', hint: 'provider timestamp → backend receipt' },
  { key: 'processing', label: 'Processing', hint: 'receipt → published to clients' },
  { key: 'normalize', label: 'Normalize', hint: 'receipt → validated quote' },
];

export function useMetrics() {
  return useQuery({
    queryKey: ['metrics'],
    queryFn: () => api.get<MetricsSummary>('/metrics/summary'),
    refetchInterval: 5000,
  });
}

export function LatencyPanel({ compact = false }: { compact?: boolean }) {
  const { data, isError } = useMetrics();
  const rows = compact ? SERIES.slice(0, 4) : SERIES;
  return (
    <Panel title="Latency" meta="p50 / p95 · rolling 500" level={compact ? 3 : 2}>
      {isError ? <p className="small muted">Metrics unavailable.</p> : null}
      <div className="table-wrap">
        <table className="ledger">
          <caption className="visually-hidden">Pipeline latency in milliseconds</caption>
          <thead>
            <tr>
              <th scope="col">Stage</th>
              <th scope="col" className="r">
                Last
              </th>
              <th scope="col" className="r">
                p50
              </th>
              <th scope="col" className="r">
                p95
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const s = data?.latency_ms[r.key];
              return (
                <tr key={r.key}>
                  <th scope="row" style={{ textTransform: 'none', letterSpacing: 0, fontSize: '0.88rem' }}>
                    {r.label}
                    {!compact ? <div className="small muted">{r.hint}</div> : null}
                  </th>
                  <td className="r num">{ms(s?.last)}</td>
                  <td className="r num">{ms(s?.p50)}</td>
                  <td className="r num">{ms(s?.p95)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="disclaimer">
        Network, provider and processing delays mean fast moves can be detected late or missed entirely.
      </p>
    </Panel>
  );
}
